import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { message } from "antd";
import { CloseOutlined, DeleteFilled, InfoFilled, LoadingOutlined, ValidateFilled, WarningFilled } from "@wepie/weet-icons";
import { useState } from "react";
import classnames from "classnames";
import button_0 from "../button/index.js";
import rc_motion from "rc-motion";
const TypeIcons = {
    success: /*#__PURE__*/ jsx(ValidateFilled, {}),
    error: /*#__PURE__*/ jsx(DeleteFilled, {}),
    info: /*#__PURE__*/ jsx(InfoFilled, {}),
    warning: /*#__PURE__*/ jsx(WarningFilled, {}),
    loading: /*#__PURE__*/ jsx(LoadingOutlined, {
        spin: true
    })
};
const ToastPanel = (props)=>{
    const { type = 'info', icon, content, onClose, actions, closeIcon = /*#__PURE__*/ jsx(CloseOutlined, {}), closable } = props;
    const iconNode = icon || TypeIcons[type || 'info'];
    const { expandActionVisible, expandText, collapseText, bodyNode, defaultCollapsed } = getExpandableConfig(props);
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: "weet-toast-panel-content",
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: classnames('weet-toast-panel-content-icon', `weet-toast-panel-content-icon-${type}`),
                        children: iconNode
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: "weet-toast-panel-content-text",
                        children: content
                    }),
                    actions ? /*#__PURE__*/ jsx("span", {
                        className: "weet-toast-panel-content-actions",
                        children: actions
                    }) : null,
                    expandActionVisible ? /*#__PURE__*/ jsx(button_0, {
                        type: "link",
                        className: "weet-toast-panel-content-expand-button",
                        size: "small",
                        onClick: ()=>setCollapsed(!collapsed),
                        children: collapsed ? expandText : collapseText
                    }) : null,
                    closable ? /*#__PURE__*/ jsx("button", {
                        className: "weet-toast-panel-content-close-icon",
                        onClick: onClose,
                        children: closeIcon
                    }) : null
                ]
            }),
            bodyNode ? /*#__PURE__*/ jsx(rc_motion, {
                visible: !collapsed,
                ...bodyMotionProps,
                children: ({ style, className }, ref)=>/*#__PURE__*/ jsx("div", {
                        className: classnames('weet-toast-panel-body', className),
                        style: style,
                        ref: ref,
                        children: /*#__PURE__*/ jsx("div", {
                            className: "weet-toast-panel-body-node",
                            children: bodyNode
                        })
                    })
            }) : null
        ]
    });
};
const MessagePurePanel = message._InternalPanelDoNotUseOrYouWillBeFired;
const ToastPurePanel = (props)=>/*#__PURE__*/ jsx(MessagePurePanel, {
        className: "weet-toast",
        content: /*#__PURE__*/ jsx(ToastPanel, {
            ...props
        })
    });
const DEFAULT_EXPAND_TEXT = "\u5C55\u5F00";
const DEFAULT_COLLAPSE_TEXT = "\u6536\u8D77";
const getExpandableConfig = (props)=>{
    const { body, expandable = true } = props;
    if (!body) return {
        expandActionVisible: false,
        expandText: DEFAULT_EXPAND_TEXT,
        collapseText: DEFAULT_COLLAPSE_TEXT,
        bodyNode: null,
        defaultCollapsed: true
    };
    if (expandable && 'object' == typeof expandable) return {
        expandActionVisible: true,
        expandText: expandable.expandText || DEFAULT_EXPAND_TEXT,
        collapseText: expandable.collapseText || DEFAULT_COLLAPSE_TEXT,
        bodyNode: body,
        defaultCollapsed: expandable.defaultCollapsed ?? true
    };
    return {
        expandActionVisible: Boolean(expandable),
        expandText: DEFAULT_EXPAND_TEXT,
        collapseText: DEFAULT_COLLAPSE_TEXT,
        bodyNode: body,
        defaultCollapsed: true
    };
};
const getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const getRealHeight = (node)=>{
    const { scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const skipOpacityTransition = (_, event)=>event?.deadline === true || 'height' === event.propertyName;
const bodyMotionProps = {
    motionName: "weet-toast-panel-body-motion-collapse",
    leavedClassName: "weet-toast-panel-body-motion-leaved",
    onAppearStart: getCollapsedHeight,
    onEnterStart: getCollapsedHeight,
    onAppearActive: getRealHeight,
    onEnterActive: getRealHeight,
    onLeaveStart: getCurrentHeight,
    onLeaveActive: getCollapsedHeight,
    onAppearEnd: skipOpacityTransition,
    onEnterEnd: skipOpacityTransition,
    onLeaveEnd: skipOpacityTransition,
    motionDeadline: 500,
    motionAppear: false
};
export { ToastPanel, ToastPurePanel, getCurrentHeight };
